export default "__VITE_ASSET__BhbXQgQ1__"